import * as tslib_1 from "tslib";
import { PropostaStateService } from './../../../../../shared/states/proposta-state.service';
import { EventEmitter, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import { FaefStateService } from './../faef-state.service';
export class DadosEmpreendimentoComponent {
    constructor(fb, state, propostaState) {
        this.fb = fb;
        this.state = state;
        this.propostaState = propostaState;
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
        this.loading = new EventEmitter(true);
        this.alive = true;
    }
    ngOnInit() {
        this.createForms();
        this.initObservers();
        this.loading.emit(true);
        this.init();
    }
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const propostaId = this.propostaState.getLast().id;
            yield this.state.init(propostaId);
            const faef = this.state.getLast();
            if (faef) {
                this.empreendimentoForm.patchValue(Object.assign({}, faef, { tipoPontoComercial: String(faef.tipoPontoComercial) }));
            }
            setTimeout(() => this.loading.emit(false), 300);
        });
    }
    ngAfterViewInit() {
        this.init();
    }
    ngOnDestroy() {
        this.alive = false;
    }
    createForms() {
        this.flagCreditoAtivo = new FormControl();
        this.instituicoesForm = new FormArray([]);
        this.empreendimentoForm = this.fb.group({
            dataInicioAtividade: ['', Validators.required],
            dataInicioPonto: ['', Validators.required],
            concorrencia: ['', Validators.required],
            tipoRenda: ['', Validators.required],
            localFuncionamento: ['', Validators.required],
            tipoPontoComercial: ['', Validators.required],
            setorEconomico: ['', Validators.required],
            flagMudancaAtividade: ['', Validators.required],
            flagExperienciaCrediticia: ['', Validators.required],
            flagCreditoAtivo: this.flagCreditoAtivo,
            faefCredito: this.instituicoesForm
        });
    }
    initObservers() {
        this.empreendimentoForm
            .get('flagExperienciaCrediticia')
            .valueChanges
            .pipe(takeWhile(() => this.alive))
            .subscribe(value => {
            if (value === 'S') {
                this.flagCreditoAtivo.setValidators([Validators.required]);
            }
            else {
                this.flagCreditoAtivo.clearValidators();
                this.flagCreditoAtivo.reset(null);
            }
        });
        this.flagCreditoAtivo
            .valueChanges
            .pipe(takeWhile(() => this.alive))
            .subscribe(value => {
            if (value !== 'S') {
                this.instituicoesForm.clear();
                this.instituicoesForm.clearValidators();
            }
        });
    }
    updateState() {
        const faef = this.empreendimentoForm.value;
        this.state.setState(Object.assign({}, faef, { tipoPontoComercial: String(faef.tipoPontoComercial), faefCredito: faef.faefCredito.map(c => ({
                localCredito: c.localCredito,
                quantidadeParcelasPendentes: Number(c.quantidadeParcelasPendentes),
                valorParcela: Number(c.valorParcela)
            })) }));
    }
    onClickNext() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.updateState();
            this.next.emit();
        });
    }
    onClickPrevious() {
        this.updateState();
        this.previous.emit();
    }
}
